import { $http } from "@2kog/pkg-common/utils/api.js";
const domain = import.meta.env.VITE_API;

export const getNotice = (slug) => {
    return $http({ domain: domain }).get(`/api/cms/common/notice`, { params: { _slug: slug } });
};
